import React, { useContext } from 'react';
import { useSelectActiveInputWidget } from 'layout/store/selectors';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { textUtils, Tooltip } from '@instinet-analytics/core-lib';
import './ActiveFiltersIndicator.scss';
import AppContext from 'app/AppContext';
import { WidgetContextProvider } from 'widgets/WidgetContext';
import { useSelectActiveInput } from 'portfolio/store/selectors';
import { RenderFilterOptions } from 'widgets/WidgetRegistry';

const { pluralise } = textUtils;

interface ActiveFiltersIndicatorProps {
    suffix?: React.ReactNode;
    options?: RenderFilterOptions;
}

export default function ActiveFiltersIndicator(
    props: ActiveFiltersIndicatorProps
) {
    const { options, suffix } = props;
    const activeInput = useSelectActiveInput();
    const activeInputWidget = useSelectActiveInputWidget();
    const {
        services: { widgetsService },
    } = useContext(AppContext);

    if (activeInput.activeInputType !== 'Widget') {
        return <></>;
    }

    if (!activeInputWidget) {
        return <></>;
    }

    const {
        id,
        component: { type },
    } = activeInputWidget;

    const renderFilter = widgetsService.getRenderFilter(type);
    if (!renderFilter) {
        return <></>;
    }

    return (
        <WidgetContextProvider
            widgetKey={id}
            widgetType={type}
            host={'layout'}
            width={0}
            height={0}
            isHovering={false}
        >
            {renderFilter(id, options)}
            {suffix ? suffix : <></>}
        </WidgetContextProvider>
    );
}

export function renderFilterIndicator(filterCount: number) {
    const desc = `Active ${pluralise(filterCount, 'Filter')}`;
    const tooltip = `${filterCount} ${desc}`;

    return (
        <div className="ActiveFiltersIndicator">
            <div className="full-width">
                <span>{filterCount}</span>
                <span>{desc}</span>
            </div>
            <div className="narrow">
                <Tooltip text={tooltip}>
                    <Icon name="filter" />
                    {filterCount > 0 && <div className="filter-indicator" />}
                </Tooltip>
            </div>
        </div>
    );
}
